var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWhatsNewInactive = function SvgWhatsNewInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D6E5F2",
    d: "m16.892 14.814.901.9a.698.698 0 0 1-.496 1.193h-10.6c-.623 0-.93-.753-.49-1.193l.902-.9v-4.186a4.88 4.88 0 0 1 3.843-4.765v-.816C10.952 4.467 11.42 4 12 4s1.048.467 1.048 1.047v.816a4.88 4.88 0 0 1 3.844 4.765z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B2C9DE",
    d: "M14 18a2 2 0 0 1-4 0h4"
  })));
};
export default SvgWhatsNewInactive;